module.exports = __webpack_public_path__ + "static/img/15.f32c0da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/15.png
// module id = ISx+
// module chunks = 0